export const playersList = [
    {
        playerName: 'Player 1',
        rowColor: '#BDC65B',
        playerRoundScore: [''],
        totalScore: 0
    },
    {
        playerName: 'Player 2',
        rowColor: '#F8D49A',
        playerRoundScore: [''],
        totalScore: 0
    }
]